import { render } from "./ListGroup.vue?vue&type=template&id=34b62882&scoped=true"
import script from "./ListGroup.vue?vue&type=script&lang=js"
export * from "./ListGroup.vue?vue&type=script&lang=js"

import "./ListGroup.vue?vue&type=style&index=0&id=34b62882&lang=css&scoped=true"

import exportComponent from "/home/runner/work/Frontend_PsicoApp/Frontend_PsicoApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b62882"]])

export default __exports__